module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 0
// module chunks = 2 3 4 6 7 8 9